import * as React from "react";
import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <>
    <rect
      className="Radio"
      x="4.5"
      y="4.5"
      width="15"
      height="15"
      rx="7.5"
      stroke="#9FA1A8"
    />
    <rect
      className="Radio-focus"
      x="2.5"
      y="2.5"
      width="19"
      height="19"
      rx="9.5"
      stroke="#1AD4FD"
      strokeWidth="3"
    />
  </>,
  "AcUnit"
);
